(() => {
  if (customElements.get('stellar-width-comparison')) return;
  class StellarWidthComparison extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      const scope = this.closest('stellar-width-guidance,stellar-feature-guidance');
      this.opener = scope && [...scope.querySelectorAll(scope.matches('stellar-feature-guidance') ? '[data-feature-popup-open]' : '[data-width-compare-open]')].find(opener => opener.closest('stellar-width-guidance,stellar-feature-guidance') === scope);
      if (!this.dialog || !this.opener || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.bindVariantColours(options);
      this.syncVariantColour();
      this.opener.setAttribute('aria-controls',this.dialog.id);
      this.opener.setAttribute('aria-expanded','false');
      this.opener.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open();
      },options);
      this.querySelectorAll('[data-width-compare-close]').forEach(button => button.addEventListener('click',() => this.dialog.close(),options));
      this.dialog.addEventListener('cancel',event => {event.preventDefault();this.dialog.close();},options);
      this.dialog.addEventListener('close',() => { if (!this.dialog.open) this.cleanup(true); },options);
      this.dialog.addEventListener('pointerdown',event => {
        this.backdropDown = this.isBackdrop(event);
      },options);
      this.dialog.addEventListener('pointerup',event => {
        if(this.backdropDown && this.isBackdrop(event)) this.dialog.close();
        this.backdropDown = false;
      },options);
    }
    bindVariantColours(options) {
      const data = this.querySelector('[data-compare-variant-colours]');
      if (!data) return;
      let colours;
      try { colours = JSON.parse(data.textContent); } catch (_) { return; }
      if (!colours || Array.isArray(colours) || typeof colours !== 'object') return;
      this.variantColours = new Map(Object.entries(colours).filter(([id, colour]) => /^\d+$/.test(id) && (colour === 'black' || colour === 'white')));
      document.addEventListener('change', event => {
        if (!event.target?.matches?.('form[id^="product-form-"] input[name="id"]')) return;
        this.updateVariantColour(String(event.target.value));
      }, options);
    }
    syncVariantColour() {
      if (!this.variantColours) return;
      const variants = new Set([...document.querySelectorAll('[id^="MainProduct-"] product-form form[id^="product-form-"] input[name="id"]')]
        .map(input => String(input.value)).filter(variant => this.variantColours.has(variant)));
      // Duplicate main forms may agree; conflicting selections are not guessed.
      if (variants.size === 1) this.updateVariantColour([...variants][0]);
    }
    updateVariantColour(variant) {
      if (!this.variantColours?.has(variant)) return;
      const colour = this.variantColours.get(variant);
      if (colour === this.dataset.compareCurrentColour) {
        this.dataset.compareCurrentVariant = variant;
        return;
      }
      const current = this.dialog.querySelector('.stellar-compare__table > thead');
      const template = this.querySelector(`template[data-compare-colour="${colour}"]`);
      const replacement = template?.content.querySelector('thead')?.cloneNode(true);
      if (!current || !replacement) return;
      current.replaceWith(replacement);
      this.dataset.compareCurrentVariant = variant;
      this.dataset.compareCurrentColour = colour;
    }
    isBackdrop(event) {
      const r = this.dialog.getBoundingClientRect();
      return event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom);
    }
    open() {
      if(this.dialog.open) { this.opener?.setAttribute('aria-expanded','true'); return; }
      this.syncVariantColour();
      this.previousFocus = document.activeElement;
      document.querySelectorAll('dialog[open]').forEach(dialog => {if(dialog !== this.dialog) dialog.close();});
      for(const modal of document.querySelectorAll('modal-dialog[open],quick-add-modal[open]')) {
        if(typeof modal.hide === 'function') modal.hide();
        else return;
      }
      this.dialog.showModal();
      document.body.classList.add('stellar-width-dialog-open');
      this.opener.setAttribute('aria-expanded','true');
      this.querySelector('[data-width-compare-close]').focus({preventScroll:true});
    }
    cleanup(restoreFocus) {
      this.opener?.setAttribute('aria-expanded','false');
      if(!document.querySelector('dialog.stellar-compare[open]')) document.body.classList.remove('stellar-width-dialog-open');
      if(restoreFocus && this.previousFocus?.isConnected && !document.querySelector('dialog[open],modal-dialog[open],quick-add-modal[open]')) this.previousFocus.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if(this.dialog?.open) this.dialog.close();
      this.cleanup(false);
      this.controller?.abort();
      this.controller = null;
      this.variantColours = null;
    }
  }
  customElements.define('stellar-width-comparison',StellarWidthComparison);

  document.addEventListener('click', event => {
    if(event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a,button');
    if(!link || link.closest('dialog')) return;
    const href = link.getAttribute('href') || '';
    const label = link.textContent.trim().toLowerCase();
    if(!link.matches('[data-width-compare-open]') && label !== 'compare sizes' && !href.includes('#stellar-size-guide')) return;
    const local = link.closest('stellar-width-guidance')?.querySelector('stellar-width-comparison:has(dialog:not(.stellar-compare--standout))');
    const comparison = local || document.querySelector('[data-global-width-comparison] stellar-width-comparison:has(dialog:not(.stellar-compare--standout))');
    if(!comparison?.dialog || typeof comparison.open !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    comparison.opener = link;
    link.setAttribute('aria-haspopup','dialog');
    link.setAttribute('aria-controls',comparison.dialog.id);
    comparison.open();
  }, true);

})();
